import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';
import { AccionClave } from '@/admin/AccionClave';
import { aplicarTemaTaller } from '@/lib/temaTaller';

// Public page of the links in our Auth e-mails (Firebase's own action URL
// cannot be changed in this project). Only mode=resetPassword is used today.
const busqueda = z.object({
  mode: z.string().optional().catch(undefined),
  oobCode: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/accion')({
  validateSearch: busqueda,
  component: Pagina,
});

function Pagina() {
  // Always Tallerza's brand here (no workshop session to theme it).
  useEffect(() => aplicarTemaTaller(null), []);
  const { mode, oobCode } = Route.useSearch();
  const navegar = useNavigate();
  return (
    <AccionClave
      modo={mode}
      codigo={oobCode}
      onIngresar={() => navegar({ to: '/ingresar', replace: true })}
    />
  );
}
